import { Product } from '@interface/product';

import { fetchProduct } from './fetch';

// Productos que se enseñan en la web pero que se agendan como otro producto.
// El GLP-1 (6 meses) siempre se agenda como "Asesoramiento pérdida de peso"
// (gratis), tanto desde la ficha como desde las landings por slug.
const APPOINTMENT_PRODUCT_BY_ID: Record<string, string | undefined> = {
  '668b678d-07ac-4431-8c44-4cf29d2d50c0':
    process.env.NEXT_PUBLIC_ASESORAMIENTO_PERDIDA_PESO_ID,
};

export function getAppointmentProductId(product?: Pick<Product, 'id'>) {
  if (!product?.id) return undefined;
  return APPOINTMENT_PRODUCT_BY_ID[product.id.toLowerCase()];
}

// En Flowww el GLP-1 es un pack (1 visita + 5 revisiones; IsPack hace que el
// presupuesto lleve el pack), pero en la web no se enseña ni se agenda como pack.
export function isWebPack(product?: Pick<Product, 'id' | 'isPack'>) {
  return !!product?.isPack && !getAppointmentProductId(product);
}

// El producto que se agenda de verdad: el asesoramiento en lugar del GLP-1.
export async function resolveAppointmentProduct(product: Product) {
  const appointmentProductId = getAppointmentProductId(product);
  if (!appointmentProductId) return product;
  const appointmentProduct = await fetchProduct(appointmentProductId, false);
  return appointmentProduct?.id ? appointmentProduct : product;
}

// La cita gratis que se agenda en su lugar: va directa a elegir clínica.
export function isAppointmentProduct(product?: Pick<Product, 'id'>) {
  if (!product?.id) return false;
  const id = product.id.toLowerCase();
  return Object.values(APPOINTMENT_PRODUCT_BY_ID).some(
    appointmentId => appointmentId?.toLowerCase() === id
  );
}
